export const CMS_PROMOTIONAL_CONTENT = "Promotional Content (201)";
export const CMS_MEDICAL_CONTENT = "Medical Content (301)";

export interface CMSRegulatoryStatus {
    promotional_or_medical: typeof CMS_PROMOTIONAL_CONTENT | typeof CMS_MEDICAL_CONTENT;
}
